import cls from 'classnames';
import React from 'react';
import useStyles from './styles';

interface IProps {
  fullWidth?: boolean;
  className?: string;
  disabled?: boolean;

  [prop: string]: unknown;
}

const Button: React.FC<IProps> = (props) => {
  const { fullWidth, className, children, disabled, ...rest } = props;
  const classes = useStyles();

  return (
    <button
      type="button"
      className={cls(classes.root, { [classes.fullWidth]: fullWidth }, { [classes.disabled]: disabled }, className)}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
